import React from 'react'
import classNames from 'classnames'

const TranscriptionIcon = ({
  active = false,
  className = '',
  stokeColor = 'currentColor',
  badgeBg = '#0A223C',
  withShadow = true,
  size = 28,
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames('transition-colors duration-200', className, {
        'cursor-pointer': onClick,
      })}
      onClick={onClick}>
      <g
        clipPath='url(#clip0_23454_22781)'
        filter={withShadow ? 'url(#filter0_d_23454_22781)' : undefined}>
        <path
          d='M12.9388 7.66406C12.9388 7.48794 12.8675 7.31904 12.7405 7.1945C12.6135 7.06996 12.4413 7 12.2617 7H6.84505C6.66548 7 6.49326 7.06996 6.36628 7.1945C6.2393 7.31904 6.16797 7.48794 6.16797 7.66406C6.16797 7.84018 6.2393 8.00909 6.36628 8.13363C6.49326 8.25816 6.66548 8.32812 6.84505 8.32812H12.2617C12.4413 8.32812 12.6135 8.25816 12.7405 8.13363C12.8675 8.00909 12.9388 7.84018 12.9388 7.66406ZM10.6367 11.2057C10.6367 11.0296 10.5654 10.8607 10.4384 10.7362C10.3114 10.6116 10.1392 10.5417 9.95964 10.5417H6.84505C6.66548 10.5417 6.49326 10.6116 6.36628 10.7362C6.2393 10.8607 6.16797 11.0296 6.16797 11.2057C6.16797 11.3818 6.2393 11.5508 6.36628 11.6753C6.49326 11.7998 6.66548 11.8698 6.84505 11.8698H9.95964C10.1392 11.8698 10.3114 11.7998 10.4384 11.6753C10.5654 11.5508 10.6367 11.3818 10.6367 11.2057Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.30645 0C5.69474 0 5.10809 0.2368 4.67554 0.658306C4.243 1.07981 4 1.6515 4 2.2476V14.7524C4 15.3485 4.243 15.9202 4.67554 16.3417C5.10809 16.7632 5.69474 17 6.30645 17H15.4516C16.0633 17 16.65 16.7632 17.0825 16.3417C17.5151 15.9202 17.7581 15.3485 17.7581 14.7524V4.67337C17.7581 4.36197 17.6541 4.05957 17.4612 3.81111L14.9467 0.568029C14.8099 0.391586 14.633 0.248461 14.4298 0.149901C14.2267 0.0513406 14.0028 2.98265e-05 13.7759 0L6.30645 0ZM5.25806 2.2476C5.25806 1.68365 5.72774 1.22596 6.30645 1.22596H13.1452V4.81966C13.1452 5.15803 13.427 5.43264 13.7742 5.43264H16.5V14.7524C16.5 15.3163 16.0303 15.774 15.4516 15.774H6.30645C5.72774 15.774 5.25806 15.3163 5.25806 14.7524V2.2476Z'
          fill='currentColor'
        />
        <g clipPath='url(#clip1_23454_22781)'>
          <rect x='13' y='9' width='11' height='11' rx='5.5' fill={badgeBg} />
          <path
            d='M18.5008 15.4737C18.2389 15.4737 18.0163 15.3893 17.8329 15.2204C17.6496 15.0515 17.5579 14.8465 17.5579 14.6053V12.8684C17.5579 12.6272 17.6496 12.4221 17.8329 12.2533C18.0163 12.0844 18.2389 12 18.5008 12C18.7627 12 18.9853 12.0844 19.1686 12.2533C19.352 12.4221 19.4436 12.6272 19.4436 12.8684V14.6053C19.4436 14.8465 19.352 15.0515 19.1686 15.2204C18.9853 15.3893 18.7627 15.4737 18.5008 15.4737ZM18.1865 17.5V16.6099C17.6417 16.5423 17.1913 16.318 16.8351 15.9368C16.4789 15.5557 16.3008 15.1118 16.3008 14.6053H16.9294C16.9294 15.0057 17.0826 15.3471 17.3892 15.6294C17.6957 15.9118 18.0662 16.0528 18.5008 16.0526C18.9353 16.0524 19.306 15.9113 19.6127 15.6291C19.9195 15.347 20.0726 15.0057 20.0722 14.6053H20.7008C20.7008 15.1118 20.5227 15.5557 20.1665 15.9368C19.8103 16.318 19.3598 16.5423 18.8151 16.6099V17.5H18.1865ZM18.5008 14.8947C18.5898 14.8947 18.6645 14.8669 18.7249 14.8114C18.7852 14.7558 18.8153 14.6871 18.8151 14.6053V12.8684C18.8151 12.7864 18.7849 12.7177 18.7246 12.6623C18.6642 12.6069 18.5896 12.5791 18.5008 12.5789C18.4119 12.5788 18.3374 12.6065 18.277 12.6623C18.2167 12.7181 18.1865 12.7868 18.1865 12.8684V14.6053C18.1865 14.6873 18.2167 14.7561 18.277 14.8117C18.3374 14.8672 18.4119 14.8949 18.5008 14.8947Z'
            fill='currentColor'
          />
        </g>
        <rect
          x='13.5'
          y='9.5'
          width='10'
          height='10'
          rx='5'
          stroke='currentColor'
        />
      </g>
      <defs>
        {withShadow && (
          <filter
            id='filter0_d_23454_22781'
            x='0'
            y='0'
            width='28'
            height='28'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'>
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='4' />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_23454_22781'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect1_dropShadow_23454_22781'
              result='shape'
            />
          </filter>
        )}
        <clipPath id='clip0_23454_22781'>
          <rect width='20' height='20' fill='white' transform='translate(4)' />
        </clipPath>
        <clipPath id='clip1_23454_22781'>
          <rect x='13' y='9' width='11' height='11' rx='5.5' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TranscriptionIcon
